<template>
<div>
    <navbar></navbar>
	<div class="row" id="body-row">
    <Sidebar></Sidebar>
	<div v-bind:class="{'col-10 col-sm-10 col-md-11 col-lg-11':collapsemenu===true,'col-9 col-sm-9 col-md-10 col-lg-10':collapsemenu===false}" id="panel-principal">
    <slot />
	</div>
    <!-- Main Col END -->
	</div>
</div>
</template>
<script>
// import '@/assets/css/content-layout/js/c1b864fb23.js'

import navbar from '@/components/layout/Navbar'
import Sidebar from '@/components/layout/Sidebar'
import { mapState } from 'vuex'
export default {

	name: 'Content',
	components: {
		navbar,
		Sidebar
	},
	mounted () {
	},
	computed: {
		...mapState(['collapsemenu'])
	}
}

</script>
<style>
#content-body {
  background-image: none;
  background-color: #ffffff;
  color:black;
}
</style>



// WEBPACK FOOTER //
// src/components/Content.vue